import { Link, useLoaderData } from "react-router";
import PdfViewer from "../components/revues-numeriques/PdfViewer";
import Title from "../components/ui/Title";
import { RevueNumerique } from "../lib/interfaces/revue-numerique.interface";
import { ArrowLeftIcon } from "lucide-react";

export default function RevueViewerPage() {
  const { revue, password } = useLoaderData() as { revue: RevueNumerique; password: string };

  return (
    <div>
      <div className='flex flex-row gap-5 mb-6 items-center'>
        <Link to='/revues-numeriques'>
          <button className='rounded-full bg-white border p-3 hover:bg-gray-50 active:bg-gray-100'>
            <ArrowLeftIcon />
          </button>
        </Link>
        <Title>{revue.nom}</Title>
      </div>

      <PdfViewer url={revue.url} password={password} />
    </div>
  );
}
